import { render, staticRenderFns } from "./RenameForm.vue?vue&type=template&id=77133209&"
import script from "./RenameForm.vue?vue&type=script&lang=js&"
export * from "./RenameForm.vue?vue&type=script&lang=js&"
import style0 from "./RenameForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77133209')) {
      api.createRecord('77133209', component.options)
    } else {
      api.reload('77133209', component.options)
    }
    module.hot.accept("./RenameForm.vue?vue&type=template&id=77133209&", function () {
      api.rerender('77133209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/dialog/RenameForm.vue"
export default component.exports